import { inject } from '@angular/core';
import type { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { map, tap, withLatestFrom } from 'rxjs';
import { PagePath } from '../enums/page-path.enum';
import { GuardsContextService } from '../services/guards-context.service';
import { NavigationService } from '../services/navigation.service';
import { PharmaciesStateService } from '../services/pharmacies-state.service';

export const selectedPharmacyForDetailsGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
  guardsContextService = inject(GuardsContextService),
  pharmaciesStateService = inject(PharmaciesStateService),
  navigationService = inject(NavigationService)
) => {
  return guardsContextService.getIsProcessingAuth$().pipe(
    withLatestFrom(pharmaciesStateService.hasSelectedPharmacyForDetails$()),
    tap(([isProcessingAuth, hasSelectedPharmacyForDetails]) => {
      if (!isProcessingAuth && !hasSelectedPharmacyForDetails) {
        navigationService.navigateToPagePath([PagePath.PHARMACIES]);
      }
    }),
    map(([isProcessingAuth, hasSelectedPharmacyForDetails]) => isProcessingAuth || hasSelectedPharmacyForDetails)
  );
};
